import { match as integer } from "../../../src/params/integer.ts";
import { match as lang } from "../../../src/params/lang.ts";

export const matchers = { integer, lang };